<div [ngClass]="{ mobile: isMobileLayout }" class="content-layout">
  <!--  LIST OF ALL LOADED DATA -->
  <div *ngIf="!isMobileLayout" class="border-end custom-scroll">
    <!-- <div class="row-2 d-flex justify-content-center"></div> -->
    <div class="justify-content-center mt-2">
      <ng-container *ngTemplateOutlet="start"></ng-container>
    </div>
  </div>

  <!-- TOP EXPANDING BAR MOBILE ONLY -->
  <div
    *ngIf="isMobileLayout"
    class="d-flex position-absolute dropdown custom-scroll w-100"
    [ngClass]="{ 'expanded flex-column': isExpanded, 'flex-row': !isExpanded }"
  >
    <div class="col-10 d-flex flex-row ps-2" *ngIf="!isExpanded">
      <div class="colfa-rotate-270 p-0 m-0 me-2">
        <!-- <svg-icon src="../../../assets/images/icons/parcel.svg" [svgStyle]="{ 'width.px': 40, 'height.px': 40 }"></svg-icon> -->
      </div>
      <div class="col-10 d-flex flex-row align-items-center">
        <!-- <p class="p-0 m-0">{{ parcels![selectedParcel].district }}</p> -->
      </div>
    </div>
    <ng-container *ngIf="isExpanded">
      <ng-container *ngTemplateOutlet="start"></ng-container>
    </ng-container>
    <div
      (click)="toggleListViewExpansion()"
      class="mobile-expand-button"
      [ngClass]="{ 'row-1': isExpanded, 'col-2': !isExpanded }"
    >
      <svg-icon
        src="../../../assets/images/icons/drop_down_arrow.svg"
        [svgStyle]="{ 'width.px': 20, 'height.px': 20 }"
        [ngClass]="{ expanded: isExpanded }"
      ></svg-icon>
    </div>
  </div>

  <!-- SELECTED DATA CONTAINER -->
  <div
    class="border-end"
    scrollSpy
    [spiedTags]="['DIV']"
    (sectionChange)="onSectionChanged($event)"
  >
    <ng-container *ngTemplateOutlet="center"></ng-container>
  </div>

  <!-- SCROLL SPY -->
  <div *ngIf="!isMobileLayout">
    <ng-container *ngTemplateOutlet="end"></ng-container>
  </div>
</div>
